module.exports = __webpack_public_path__ + "img/widget_dm.00b44595.svg";